import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { X, MessageCircle, ChefHat } from "lucide-react";
import { Fireworks } from "@/components/Fireworks";

import API from "../apiBase";

export const ParlaModal = ({ whatsappLink, onClose }) => {
  const [shower, setShower] = useState(false);
  const [sorpresaSrc, setSorpresaSrc] = useState(null);
  const sorpresaRef = useRef(null);

  /* audio sorpresa: basta un file (mp3/ogg/wav/m4a) in public/sorpresa/ */
  useEffect(() => {
    fetch(`${API}/api/sorpresa`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("sorpresa"))))
      .then((d) => {
        if (d.src) setSorpresaSrc(encodeURI(d.src));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const acceptInvite = () => {
    /* niente preventDefault e niente timer: il link deve aprirsi
       SUBITO, nel gesto del click, o i browser lo bloccano come popup */
    if (shower) return;
    setShower(true);
    document.getElementById("bg-music")?.pause();
    const s = sorpresaRef.current;
    if (s) {
      s.currentTime = 0;
      s.play().catch(() => {});
    }
  };

  return (
    <motion.div
      className="modal-backdrop"
      data-testid="parla-modal"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.35 }}
      onClick={onClose}
    >
      {shower && <Fireworks />}
      {sorpresaSrc && (
        <audio
          ref={sorpresaRef}
          src={sorpresaSrc}
          preload="auto"
          data-testid="sorpresa-audio"
        />
      )}
      <motion.div
        className="modal-card"
        role="dialog"
        aria-modal="true"
        aria-label="Invito a cena"
        initial={{ opacity: 0, y: 60, scale: 0.92 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 40, scale: 0.94 }}
        transition={{ type: "spring", stiffness: 240, damping: 22 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="modal-close"
          onClick={onClose}
          aria-label="Chiudi finestra"
          data-testid="modal-close-btn"
        >
          <X size={18} />
        </button>
        <div className="modal-icon">
          <ChefHat size={26} />
        </div>
        <h3 className="modal-title">Un invito, dal vivo</h3>
        <p className="modal-text">
          Ho un'idea semplice: due caffè, una passeggiata e qualche parola che
          preferisco dirti guardandoti negli occhi. Gli ingredienti li
          conosciamo: un po' di curiosità, qualcosa da raccontarci e una
          strada da scegliere sul momento.
        </p>
        <p className="modal-text modal-text--soft">
          Il resto lo lasciamo alla serata. Ti va di incontrarci?
        </p>
        <motion.a
          className="whatsapp-btn"
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          onClick={acceptInvite}
          data-testid="whatsapp-cta-btn"
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.96 }}
        >
          <MessageCircle size={18} />
          {shower ? "Si accende il cielo…" : "Accetto l'invito"}
        </motion.a>
        <p className="modal-hint">ti scriverò su WhatsApp ✦</p>
      </motion.div>
    </motion.div>
  );
};
